var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuVesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.92193,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_1862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9308 13.2529H16.694C16.694 13.2529 15.7019 18.7471 20.5119 20.7656C23.0127 21.8158 23.7927 23.2527 23.7927 25.4798",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5625 13.2529H33.7993C33.7993 13.2529 34.7914 18.7471 29.9814 20.7656C27.4807 21.8158 26.7007 22.7395 26.7007 25.4798",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9308 37.2002H16.694C16.694 37.2002 15.7019 31.7915 20.5119 29.7697C23.0127 28.7194 23.7927 27.2381 23.7927 25.0144",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5625 37.2002H33.7993C33.7993 37.2002 34.7914 31.7915 29.9814 29.7697C27.4807 28.7194 26.7007 27.7512 26.7007 25.0144",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9561 33.208C19.354 34.1488 19.3164 35.1477 19.3164 35.1477H31.1772C31.1772 35.1477 31.1396 34.1522 30.5477 33.208H19.9561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5586 16.7869C19.8528 17.625 20.5028 18.6821 21.9499 19.0961C24.4918 19.8213 25.2478 21.7919 25.2478 21.7919C25.2478 21.7919 26.0039 19.859 28.5457 19.1337C29.9996 18.7198 30.6496 17.6387 30.9404 16.7869H19.5586Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_1862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3255,
    height: 26,
    fill: "white",
    transform: "translate(15.582 12.2266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuVesting);
export default __webpack_public_path__ + "static/media/icon_menu_vesting.987abfd75eacfac8685a9463cf67d46a.svg";
export { ForwardRef as ReactComponent };